import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { ConcursosComponent } from './concursos.component';

import { ConcursosService } from './concursos.service';
import { ListConcursosService } from './list.service';
import { ConcursosResumeComponent } from './concursos.resume/concursos.resume.component';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    ListConcursosService,
    ConcursosService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    } 
  ],
  declarations: [
    ConcursosComponent,
    ConcursosResumeComponent
  ],
  exports: [
    ConcursosComponent
  ]
})
export class ConcursosModule { }